module.exports = __webpack_public_path__ + "img/house.aba1fba9.png";